<div class="header-container" [ngClass]="{'pip': isPip()}">
    <div class="flex justify-between">
        <div class="flex controls">
            @if(isPip()){
            <rounded-icon-button class="relative" [size]="'large'" data-testid="player_pip-exit"
                [imgSrc]="skinning.getImage('icon_PiP_exit')" (onClick)="togglePip()"></rounded-icon-button>
            }@else{
            @if(isChannel() && isCurrentItemLive()){
            <div class="channels-container">
                <div class="channel-button cursor-pointer flex items-center justify-between" data-testid="player_channels">
                    <img class="icon ms-5" src="{{channelIcon()}}">
                    <i class="pi pi-chevron-down me-3 arrow"></i>
                </div>
                <player-channels></player-channels>
            </div>
            }
            }
        </div>
        <div class="flex controls">
            <!-- Cast button only when a device is actually discoverable (Google UX). -->
            @if(!isAdvertisingRunning() && isCastAvailable()){
            <rounded-icon-button class="relative" [size]="'large'" data-testid="player_cast"
                [imgSrc]="skinning.getImage('icon_cast_disconnected')"
                (onClick)="toggleCast()"></rounded-icon-button>
            }
            <rounded-icon-button class="relative" [size]="'large'" data-testid="player_details"
                [imgSrc]="skinning.getImage('icon_more_round')" (onClick)="openDetails()"></rounded-icon-button>
            <rounded-icon-button class="relative" [size]="'large'" data-testid="player_close"
                [imgSrc]="skinning.getImage('icon_close')" (onClick)="close()"></rounded-icon-button>
        </div>
    </div>
    <!-- Compact layout (phones, tablet portrait): the title moves up here, the controls keep only transport. -->
    @if(!isPip() && isCompactLayout()?.matches){
    <div class="flex flex-col items-center">
        <h4>{{itemSeriesTitle()}}</h4>
        <h2 data-testid="player_title">{{itemTitle()}}</h2>
    </div>
    }
</div>
